module.exports = __webpack_public_path__ + "static/Brigitta-aa3bd1ea510450bd83d1ea4b66826944.jpg";